export interface PinDisplayProps {
  /** Vierstellige PIN als String -- fuehrende Nullen bleiben so erhalten. */
  pin: string;
  label: string;
}

/**
 * Anzeige der eigenen PIN.
 *
 * Bewusst keine Eingabefelder: die PIN wird vom Server vergeben und nur
 * abgelesen. Sie steht zusaetzlich als zusammenhaengender Text in einer
 * versteckten Zeile, weil vier einzeln vorgelesene Ziffern schwer zu merken
 * sind. `font-variant-numeric: tabular-nums` verhindert, dass die Kaesten beim
 * Wechsel der Ziffern springen.
 */
export function PinDisplay({ pin, label }: PinDisplayProps): React.ReactElement {
  const digits = pin.split("");

  return (
    <div>
      <span className="visually-hidden">{`${label}: ${digits.join(" ")}`}</span>
      <div className="pin-display" aria-hidden="true">
        {digits.map((digit, index) => (
          // Die Position ist die Identitaet; die Reihenfolge aendert sich nie.
          // eslint-disable-next-line react/no-array-index-key
          <span key={index} className="pin-display__digit">
            {digit}
          </span>
        ))}
      </div>
    </div>
  );
}
